<div class="row">
  <div class="col-md col-lg">
      <mat-card>
          <!-- <mat-card-title class="text-center">Leitura do código de barra para o campo {{field}} </mat-card-title>
          <mat-divider></mat-divider>
          <br>
          -->
        <div class="row justify-content-md-right">
            <div class="col-md-10">
                <h2 class="texto">  </h2>
            </div>
            <div class="col-md-2">
                <div mat-card-avatar style="background-image: 'url(../../../assets/logoseedsview.png)'; height: 80px !important;
                width: 80px !important;" class="imageCard"></div>
            </div>
            <hr>
        </div>

          <div *ngIf="enableSabugo || enableSabugoI || enableSabugoII || enableSabugoIII">
              <p><b>Sabugo/pedúnculo:</b></p>
              <div *ngIf="enableSabugo">
                  <p>- Se houver <b>sabugos/pedúnculos</b> grandes na massa boa, reduzir a peneira de topo (não menos
                      que
                      24*) e
                      checar possível vazamento na peneira de topo.
                  </p>
                  <p>
                      <i>(*) Não é recomendado usar peneira de topo abaixo da 25 para os hy: AG8780PRO3, DKB290PRO3,
                          AG8690PRO3, 3700RR2, AS1666PRO3, DKB177PRO3, AG1051, AS1868PRO3</i>
                  </p>
                  <p>- Caso haja presença de <b>sabuguinhos</b>, aumentar a regulagem 3 (ar da pré-sucção) e reavaliar
                      o
                      descarte
                      da pré-sucção. Caso ainda persista, aumentar ligeiramente a regulagem 1 (velocidade do ar).</p>
              </div>
              <div *ngIf="enableSabugoI">
                  <p>- Contrato GRANEL com alta possibilidade de presença de sabugo/pedúnculo, segundo CD006. Checar
                      se o descarte do topo está muito alto. Se estiver, pode ser entupimento na peneira de topo.
                      Abrir para realizar a troca da peneira topo ou limpeza.
                  </p>
              </div>
              <div *ngIf="enableSabugoII">
                  <p>- Contrato com alta possibilidade de presença de sabugo/pedúnculo, segundo CD006. Checar se o
                      descarte do topo está muito alto. Se estiver, pode ser entupimento na peneira de topo. Abrir
                      para realizar a troca da peneira topo ou limpeza.
                  </p>
              </div>
              <div *ngIf="enableSabugoIII">
                  <p>- Contrato GRANEL. Checar se o descarte do topo está muito alto. Se estiver, pode ser entupimento
                      na peneira de topo. Abrir para realizar a troca da peneira topo ou limpeza.
                  </p>
              </div>
          </div>
          <div *ngIf="enablePo">
              <p><b>Pó:</b></p>
              <p>- Há pó na massa boa, aumentar a regulagem 3 (ar da pré-sucção) e reavaliar o descarte da pré-sucção.
                  Caso ainda persista, aumentar ligeiramente a regulagem 1 (velocidade do ar). Verificar também a
                  regulagem e bom funcionamento do Cyclofan.</p>
          </div>
          <div *ngIf="enableFundo">
              <p><b>Fundo:</b></p>
              <p>- Há fundo na massa boa, verificar se as peneiras de fundo estão obstruídas e limpar caso necessário.
              </p>
          </div>
          <div *ngIf="enablePesoMaior || enablePesoMenor">
              <p><b>Eficiência de limpeza da coluna de ar:</b></p>
              <div *ngIf="enablePesoMaior">
                  <p>- A diferença de peso hectolítrico está alta, significa que está retirando apenas defeitos muito
                      leves. Sugestão de regulagem: avaliar o aumento da regulagem 6 (volume de ar da coluna), ajustar
                      regulagem 4 (altura da coifa) e ajustar a altura da chapa metálica (ver imagem - item 9). (**)
                  </p>
                  <p>
                      <i>(**) A amostra de descarte usada para diferença de peso hectolítrico deve ser da coluna de ar
                          da
                          Cimbria.</i>
                  </p>
                  <img mat-card-image src="../../../assets/ajusteGuideCd001.png">
              </div>
              <div *ngIf="enablePesoMenor">
                  <p>- A diferença de peso hectolítrico está baixa, significa que tem sementes boas sendo descartadas.
                      Sugestão de regulagem: Reduzir o ajuste 6 (volume de ar da coluna) e reduzir o ajuste 4 (altura
                      da
                      coifa). (**)
                  </p>
                  <p>
                      <i>(**) A amostra de descarte usada para diferença de peso hectolítrico deve ser da coluna de ar
                          da
                          Cimbria.</i>
                  </p>
              </div>
          </div>
          <div *ngIf="enableOk">
              <p>- De acordo com os dados preenchidos, a regulagem da Pré-Limpeza Cimbria está adequada!
              </p>
          </div>
          <!-- <br>
          <p [hidden]="true">O Codigo de Barra lido é {{scannerCode}}</p> -->
          <mat-card-actions class="text-right">
              <button mat-button mat-flat-button color="accent" matTooltip="Fechar" (click)="closeModal()"><i
                      class="fa fa-close" aria-hidden="true"></i> Fechar</button>
          </mat-card-actions>
      </mat-card>
  </div>
</div>